import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button as MuiButton,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { TabView, TabPanel } from "primereact/tabview";
import DyanmicDataList from "components/DyanmicDataList";
import _ from "lodash";
import APIConstant from "utils/constant";
import api from "utils/api";
import ColumnDropdown from "components/DropDown";
import Loader from "components/Shared/Loader/Loader";
import cogoToast from "cogo-toast";
import yes from "../../assets/images/yesmarkblank.png";
import { CommonConfig } from "CommonConfig";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

const initialCustomerDetails = {
  CustomerName: "",
  CustomerNameErr: false,
  CustomerNameErrText: "",
  Code: "",
  Gender: "",
  DateOfBirth: "",
  Age: "",
  ContactNo: "",
  EmailId: "",
  Address: "",
  City: "",
  State: "",
  PinCode: "",
  CompanyName: "",
};

const initialCompanyDetails = {
  CompanyName: "",
  TradeName: "",
  Address: "",
  State: "",
  City: "",
};

const initialStaffDetails = {
  StaffName: "",
  StaffNameErr: false,
  StaffNameErrText: "",
  Gender: "",
  DateOfBirth: "",
  ContactNo: "",
  Pin: "",
  PinErr: "",
  PinErrText: "",
};

const initialBranchDetails = {
  BranchName: "",
  Address: "",
  ContactPersons: [""],
  Post: "",
  MobileNo: "",
  EmailId: "",
};

const AddNetwork = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [networkId, setNetworkId] = useState("");
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("Customer");
  const [currentTab, setCurrentTab] = useState(0);
  const [gst, setGst] = useState({
    gst: "",
    gstErr: false,
    gstErrText: "",
    isVerified: false,
  });
  const [pan, setPan] = useState({
    pan: "",
    panErr: false,
    panErrText: "",
    isVerified: false,
  });
  const [companyDetails, setCompanyDetails] = useState(initialCompanyDetails);
  const [branchDialog, setBranchDialog] = useState(false);
  const [networkBranchId, setNetworkBranchId] = useState("");
  const [branches, setBranches] = useState([]);
  const [newBranch, setNewBranch] = useState(initialBranchDetails);
  const [readOnly, setReadOnly] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(
    initialCustomerDetails
  );
  const [staffDetails, setStaffDetails] = useState(initialStaffDetails);

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      let id = props.location?.state?.NetworkBranchId;

      if (props.location?.state && props.location.state.NetworkId) {
        setNetworkId(props.location.state.NetworkId);
        GetNetworkById(data, props.location.state.NetworkId);
      } else {
        // GenerateUniqueCustomerCode(data);
      }
      getDataTableOrderList(data, id);
      setNetworkBranchId(id);
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    if (userType === "Supplier") {
      setCustomerDetails(initialCustomerDetails);
      setStaffDetails(initialStaffDetails);
    } else if (userType === "Customer") {
      if (!props?.location?.state?.NetworkId) {
        // GenerateUniqueCustomerCode(userId);
      }
      setNewBranch(initialBranchDetails);
      setBranches([]);
      setCompanyDetails(initialCompanyDetails);
      setStaffDetails(initialStaffDetails);
    } else if (userType === "Staff") {
      setCompanyDetails(initialCompanyDetails);
      setCustomerDetails(initialCustomerDetails);
    }
    setGst({
      gst: "",
      gstErr: false,
      gstErrText: "",
      isVerified: false,
    });
    setPan({
      pan: "",
      panErr: false,
      panErrText: "",
      isVerified: false,
    });
  }, [userType]);

  const GenerateUniqueCustomerCode = (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GenerateUniqueCustomerCode, params)
      .then(async (res) => {
        if (res.Success === 1) {
          setCustomerDetails((prev) => ({ ...prev, Code: res.generatedID }));
        }
      })
      .catch((err) => {});
  };

  const AddUpdateNetwork = async () => {
    setLoading(true);
    if (validate()) {
      try {
        let params = {
          UserId: userId,
          UserType: userType,
          NetworkId: networkId,
          NetworkBranchId: networkBranchId,
          CompanyDetails: {
            CompanyName: companyDetails.CompanyName,
            Address: companyDetails.Address,
            State: companyDetails.State,
            GST: gst.gst,
            IsGstVerified: gst.isVerified,
            Pan: pan.pan,
            IsPanVerified: pan.isVerified,
          },
          Branches: branches.map((branch) => ({
            BranchName: branch.BranchName,
            Address: branch.Address,
            Post: branch.Post,
            MobileNo: branch.MobileNo,
            EmailId: branch.EmailId,
            ContactPersons: branch.ContactPersons,
          })),
        };
        let params1 = {
          UserId: userId,
          UserType: userType,
          NetworkId: networkId,
          CustomerDetails: {
            CustomerName: customerDetails.CustomerName,
            Code: customerDetails.Code,
            Gender: customerDetails.Gender,
            DateOfBirth: customerDetails.DateOfBirth,
            Age: customerDetails.Age,
            ContactNo: customerDetails.ContactNo,
            EmailId: customerDetails.EmailId,
            Address: customerDetails.Address,
            City: customerDetails.City,
            State: customerDetails.State,
            PinCode: customerDetails.PinCode,
            CompanyName: customerDetails.CompanyName,
            GST: gst.gst,
            IsGstVerified: gst.isVerified,
            Pan: pan.pan,
            IsPanVerified: pan.isVerified,
          },
        };
        let params2 = {
          UserId: userId,
          UserType: userType,
          NetworkId: networkId,
          StaffDetails: {
            StaffName: staffDetails.StaffName,
            Gender: staffDetails.Gender,
            DateOfBirth: staffDetails.DateOfBirth,
            ContactNo: staffDetails.ContactNo,
            Pin: staffDetails.Pin,
          },
        };
        let actualParams =
          userType === "Customer"
            ? params1
            : userType === "Staff"
            ? params2
            : params;
        api
          .post(APIConstant.path.AddUpdateNetwork, actualParams)
          .then((response) => {
            setLoading(false);
            if (response.Success === 1) {
              props.history.push("/admin/network");
              cogoToast.success(response.Message);
            } else {
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const GetNetworkById = async (UserId, NetworkId) => {
    try {
      let params = {
        UserId,
        NetworkId,
      };
      api
        .post(APIConstant.path.GetNetworkById, params)
        .then((response) => {
          if (response.Success === 1) {
            let data = response.Data;
            setUserType(data.UserType);
            if (data.UserType === "Customer") {
              if (data.CustomerDetails.DateOfBirth) {
                data.CustomerDetails.DateOfBirth = new Date(
                  data.CustomerDetails.DateOfBirth
                );
              }
              setCustomerDetails(data.CustomerDetails);
              setGst((prevState) => ({
                ...prevState,
                gst: data.CustomerDetails.GST,
                isVerified: data.CustomerDetails.IsGSTVerified,
              }));
              setPan((prevState) => ({
                ...prevState,
                pan: data.CustomerDetails.Pan,
                isVerified: data.CustomerDetails.IsPanVerified,
              }));
            } else if (data.UserType === "Staff") {
              if (data.StaffDetails.DateOfBirth) {
                data.StaffDetails.DateOfBirth = new Date(
                  data.StaffDetails.DateOfBirth
                );
              }
              setStaffDetails(data.StaffDetails);
            } else {
              setCompanyDetails(data.CompanyDetails);
              setBranches(data.Branches);
              setGst((prevState) => ({
                ...prevState,
                gst: data.CompanyDetails.GST,
                isVerified: data.CompanyDetails.IsGSTVerified,
              }));
              setPan((prevState) => ({
                ...prevState,
                pan: data.CompanyDetails.Pan,
                isVerified: data.CompanyDetails.IsPanVerified,
              }));
            }
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const validate = () => {
    let isValid = true;
    // if (CommonConfig.isEmpty(gst.gst) && CommonConfig.isEmpty(pan.pan)) {
    //   cogoToast.error("Please enter GST or Pan");
    //   isValid = false;
    // }
    //  else if (!gst.isVerified || !pan.isVerified) {
    //   cogoToast.error("Please verify GST or Pan");
    //   isValid = false;
    // }

    if (userType === "Customer") {
      if (
        CommonConfig.isEmpty(customerDetails.CustomerName) &&
        CommonConfig.isEmpty(customerDetails.ContactNo)
      ) {
        cogoToast.error("Please enter customer name or contact no");
        isValid = false;
      }
    } else if (userType === "Staff") {
      let updatedStaff = { ...staffDetails };

      const formFieldsToValidate = [
        { key: "StaffName", label: "Staff Name" },
        { key: "Pin", label: "Pin" },
      ];

      formFieldsToValidate.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(updatedStaff[key])) {
          isValid = false;
          updatedStaff[`${key}Err`] = true;
          updatedStaff[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedStaff[`${key}Err`] = false;
          updatedStaff[`${key}ErrText`] = "";
        }
      });
      setStaffDetails(updatedStaff);
    } else {
      let updatedCompany = { ...companyDetails };

      const formFieldsToValidate = [
        { key: "CompanyName", label: "Company Name" },
      ];

      formFieldsToValidate.forEach(({ key, label }) => {
        if (CommonConfig.isEmpty(updatedCompany[key])) {
          isValid = false;
          updatedCompany[`${key}Err`] = true;
          updatedCompany[`${key}ErrText`] = `${label} is required`;
        } else {
          updatedCompany[`${key}Err`] = false;
          updatedCompany[`${key}ErrText`] = "";
        }
      });
      setCompanyDetails(updatedCompany);
    }
    return isValid;
  };

  const handleVerify = () => {
    try {
      let params = {
        UserId: userId,
        gst: gst.gst,
        token: localStorage.getItem("Token"),
      };
      api
        .post(APIConstant.path.GetGSTVerifyData, params)
        .then((response) => {
          if (
            response.Success === 1 &&
            response.Info.VerifyGST &&
            response.Info.VerifyGST.code &&
            response.Info.VerifyGST.code == 200
          ) {
            setGst((prevState) => ({
              ...prevState,
              IsGstVerified: true,
            }));
            if (userType === "Supplier") {
              setCompanyDetails({
                CompanyName: response.Info.VerifyGST.response.legal_name,
                TradeName: response.Info.VerifyGST.response.trade_name,
                State: response.Info.VerifyGST.response.Address.state,
                Address:
                  response.Info.VerifyGST.response.Address.addr1 +
                  response.Info.VerifyGST.response.Address.addr2,
              });
            } else {
              setCustomerDetails((prevState) => ({
                ...prevState,
                City: response.Info.VerifyGST.response.Address.city,
                State: response.Info.VerifyGST.response.Address.state,
                Address:
                  response.Info.VerifyGST.response.Address.addr1 +
                  response.Info.VerifyGST.response.Address.addr2,
                PinCode: response.Info.VerifyGST.response.Address.pin,
                CustomerName: response.Info.VerifyGST.response.legal_name,
                CompanyName: response.Info.VerifyGST.response.trade_name,
                pan: extractPANFromGST(gst.gst),
              }));
            }
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const handlePanVerify = () => {
    try {
      let params = {
        UserId: userId,
        pan: pan.pan,
        token: localStorage.getItem("Token"),
      };
      api
        .post(APIConstant.path.GetPanVerifyData, params)
        .then((response) => {
          if (
            response.Success === 1 &&
            response.Info.VerifyPAN &&
            response.Info.VerifyPAN.code &&
            response.Info.VerifyPAN.code == 200
          ) {
            setPan((prevState) => ({
              ...prevState,
              IsPanVerified: true,
            }));
            if (userType === "Supplier") {
              setCompanyDetails({
                CompanyName: response.Info.VerifyPAN.response.registered_name,
              });
            } else {
              setCustomerDetails((prevState) => ({
                ...prevState,
                CustomerName: response.Info.VerifyPAN.response.registered_name,
                CompanyName: response.Info.VerifyPAN.response.registered_name,
              }));
            }
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const extractPANFromGST = (gstin) => {
    if (typeof gstin !== "string" || gstin.length !== 15) return "";

    const pan = gstin.substring(2, 12);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    return panRegex.test(pan) ? pan : "";
  };

  const validateBranch = () => {
    let isValid = true;

    let updatedBranch = { ...newBranch };

    const formFieldsToValidate = [
      { key: "BranchName", label: "Branch Name" },
      { key: "Address", label: "Address" },
      { key: "Post", label: "Post" },
      { key: "MobileNo", label: "Mobile No" },
      { key: "EmailId", label: "Email Id" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedBranch[key])) {
        isValid = false;
        updatedBranch[`${key}Err`] = true;
        updatedBranch[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedBranch[`${key}Err`] = false;
        updatedBranch[`${key}ErrText`] = "";
      }
    });

    if (
      updatedBranch.EmailId &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(updatedBranch.EmailId)
    ) {
      isValid = false;
      updatedBranch.EmailIdErr = true;
      updatedBranch.EmailIdErrText = "Please enter valid email id";
    }

    let tempPersons = updatedBranch.ContactPersons.filter((cp) => !!cp);
    if (tempPersons < 1) {
      isValid = false;
      cogoToast.error("Please enter contact person details");
    }

    setNewBranch(updatedBranch);

    return isValid;
  };

  const addBranch = () => {
    if (validateBranch()) {
      setBranches([...branches, { ...newBranch }]);
      setNewBranch({
        BranchName: "",
        Address: "",
        ContactPersons: [""],
        Post: "",
        MobileNo: "",
        EmailId: "",
      });
      setBranchDialog(false);
    }
  };

  const removeBranch = (id) => {
    setBranches(branches.filter((b) => b.id !== id));
  };

  let columns = [
    { id: 1, field: "SrNo", header: "Sr. No", isChecked: true },
    { id: 2, field: "BranchName", header: "Branch Name", isChecked: true },
    { id: 3, field: "Address", header: "Address", isChecked: true },
    {
      id: 4,
      field: "ContactPersons",
      header: "Contact Person(s)",
      isChecked: true,
    },
    { id: 5, field: "Post", header: "Post", isChecked: true },
    { id: 6, field: "MobileNo", header: "Mobile No", isChecked: true },
    { id: 7, field: "EmailId", header: "Email Id", isChecked: true },
    { id: 8, field: "actions", header: "Actions", isChecked: true },
  ];

  let [initialColumns, setInitialColumns] = useState(_.cloneDeep(columns));
  let [filterInitialColumns, setFilterInitialColumns] = useState(
    _.cloneDeep(columns)
  );

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      filterInitialColumns,
      result.source.index,
      result.destination.index
    );
    setFilterInitialColumns(items);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const handleCheckBoxChange = (e, index) => {
    let tempColumnList = [...filterInitialColumns];
    tempColumnList[index].isChecked = e.checked;
    setFilterInitialColumns([...tempColumnList]);
  };

  const handleColumnSave = (item) => {
    try {
      let data = {
        UserId: userId,
        Type: `Inward-${networkBranchId}`,
        Column: item.map((x) => {
          return { ...x, isChecked: x?.isChecked ? 1 : 0 };
        }),
      };
      api
        .post(APIConstant.path.AddUpdateDataOrder, data)
        .then(async (res) => {
          if (res?.Success == 1) {
            cogoToast.success(res.Message);
            await getDataTableOrderList(userId);
            Loader.hide();
          } else {
            cogoToast.error(res.Message);
            Loader.hide();
          }
        })
        .catch((err) => {
          cogoToast.error(err);
          Loader.hide();
        });
    } catch (err) {
      cogoToast.error(err);
      Loader.hide();
    }
  };

  const getDataTableOrderList = async (ID) => {
    try {
      let data = {
        UserId: ID,
        Type: `Inward-${networkBranchId}`,
      };
      await api
        .post(APIConstant.path.GetDataOrder, data)
        .then(async (res) => {
          let response = res?.Data;
          if (res.Success == 1) {
            if (response?.length) {
              const apiColumnMap = {};

              response.forEach((apiCol) => {
                apiColumnMap[apiCol.field] = apiCol;
              });

              const updatedInitialColumns = response
                ?.map((apiCol) => {
                  const initialCol = initialColumns.find(
                    (col) => col.field === apiCol.field
                  );
                  if (initialCol) {
                    initialCol.isChecked = Boolean(Number(apiCol.IsChecked));
                    return initialCol;
                  }
                  return null;
                })
                .filter(Boolean);

              setInitialColumns(_.cloneDeep(updatedInitialColumns));
              setFilterInitialColumns(_.cloneDeep(updatedInitialColumns));
            } else {
              setInitialColumns(initialColumns);
              setFilterInitialColumns(initialColumns);
            }

            Loader.hide();
          } else {
            Loader.hide();
          }
        })
        .catch((err) => {
          Loader.hide();
          console.log("catch", err);
        });
    } catch (err) {
      Loader.hide();
      console.log("catch1", err);
    }
  };

  const handleChange = (value, type, regex) => {
    if (type === "gst") {
      if (CommonConfig.isEmpty(value)) {
        setGst({
          gst: "",
          gstErr: true,
          gstErrText: "This field is required",
        });
      } else {
        setGst({
          gst: value,
          gstErr: false,
          gstErrText: "",
        });
        let pan = extractPANFromGST(value);
        if (pan) {
          setPan({
            pan: pan,
            panErr: false,
            panErrText: "",
          });
        }
      }
    } else if (type === "pan") {
      if (CommonConfig.isEmpty(value)) {
        setPan({
          pan: "",
          panErr: true,
          panErrText: "This field is required",
        });
      } else {
        setPan({
          pan: value,
          panErr: false,
          panErrText: "",
        });
      }
    } else {
      if (CommonConfig.isEmpty(value)) {
        setCompanyDetails((prev) => ({
          ...prev,
          [type]: "",
          [`${type}Err`]: true,
          [`${type}ErrText`]: `This field is required`,
        }));
      } else {
        if (!regex || regex.test(value)) {
          setCompanyDetails((prev) => ({
            ...prev,
            [type]: value,
            [`${type}Err`]: false,
            [`${type}ErrText`]: "",
          }));
        }
      }
    }
  };

  const handleBranchChange = (value, field, regex) => {
    if (!value) {
      setNewBranch((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setNewBranch((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleCustomerDetailsChange = (value, field, regex) => {
    if (!value) {
      let extraObj = {};
      if (field === "DateOfBirth") {
        extraObj.Age = "";
      }
      setCustomerDetails((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
        ...extraObj,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        if (field === "DateOfBirth") {
          const dateOfBirth = new Date(value);
          if (!isNaN(dateOfBirth)) {
            const today = new Date();
            let age = today.getFullYear() - dateOfBirth.getFullYear();
            const monthDiff = today.getMonth() - dateOfBirth.getMonth();
            const dayDiff = today.getDate() - dateOfBirth.getDate();

            // Adjust age if birthdate hasn't occurred yet this year
            if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
              age--;
            }

            extraObj.Age = age.toString(); // Store age as string if your InputText expects it
          } else {
            extraObj.Age = "";
          }
        }
        setCustomerDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleStaffDetailsChange = (value, field, regex) => {
    if (!value) {
      let extraObj = {};
      setStaffDetails((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
        ...extraObj,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setStaffDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleClose = () => {
    setBranchDialog(false);
    setNewBranch({
      BranchName: "",
      Address: "",
      ContactPersons: [""],
      Post: "",
      MobileNo: "",
      EmailId: "",
    });
    if (props?.isAddNetwork) {
      props.handleClose("addSupplier");
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center p-jc-between p-w-100">
          <div className="p-d-flex p-ai-center">
            <i
              className="pi pi-arrow-right rotate"
              onClick={() => {
                if (props?.isAddNetwork) {
                  props.handleClose("addSupplier");
                } else {
                  props.history.push("/admin/network");
                }
              }}
            />
            <h2>Add Network</h2>
          </div>
          <div className="p-field-radiobutton p-mt-3">
            <label>User Type: </label>
            <RadioButton
              inputId="customer"
              name="userType"
              value="Customer"
              disabled={!!networkId}
              onChange={(e) => setUserType(e.value)}
              checked={userType === "Customer"}
              className="p-ml-3"
            />
            <label htmlFor="customer" className="p-ml-2 p-mr-4">
              Customer
            </label>
            <RadioButton
              inputId="supplier"
              name="userType"
              value="Supplier"
              disabled={!!networkId}
              onChange={(e) => setUserType(e.value)}
              checked={userType === "Supplier"}
            />
            <label htmlFor="supplier" className="p-ml-2">
              Supplier
            </label>
            <RadioButton
              inputId="staff"
              name="userType"
              value="Staff"
              disabled={!!networkId}
              onChange={(e) => setUserType(e.value)}
              checked={userType === "Staff"}
            />
            <label htmlFor="supplier" className="p-ml-2">
              Staff
            </label>
          </div>
        </div>
      </div>
      <hr />
      <div className="p-mt-4">
        {userType === "Supplier" && (
          <>
            <TabView
              activeIndex={currentTab}
              onTabChange={(e) => {
                console.log(e.index);
                setCurrentTab(e.index);
              }}
            >
              <TabPanel className="p-mb-2" header="Company Details">
                <div className="container-body e-container-body">
                  <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card p-mt-4">
                    <div className="p-grid">
                      <div className="p-sm-12 p-md-4">
                        <div className="p-w-100 ">
                          <div className="custom-inputs e-order-mng">
                            <p className="text p-mb-1">GST No</p>
                            {readOnly ? (
                              <p className="sub-text"> {gst.gst}</p>
                            ) : (
                              <div className="p-d-flex">
                                <div className="p-w-100">
                                  <InputText
                                    autoFocus
                                    className="p-w-100 e-input-common"
                                    id="GstNo"
                                    type="text"
                                    placeholder="GST No"
                                    value={gst.gst}
                                    maxLength={20}
                                    onChange={(e) =>
                                      handleChange(e.target.value, "gst")
                                    }
                                  />
                                  {/* <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {gst.gstErr ? gst.gstErrText : null}
                              </span> */}
                                </div>
                                {gst.isVerified ? (
                                  <img
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      marginInlineEnd: "2px",
                                    }}
                                    src={yes}
                                  />
                                ) : (
                                  <Button
                                    label="Verify"
                                    disabled={!gst.gst}
                                    onClick={handleVerify}
                                    className="e-add-btn p-ml-1 p-mt-1"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="p-sm-12 p-md-4">
                        <div className="p-w-100 ">
                          <div className="custom-inputs e-order-mng">
                            <p className="text p-mb-1">Pan No</p>
                            {readOnly ? (
                              <p className="sub-text"> {pan.pan}</p>
                            ) : (
                              <div className="p-d-flex p-ai-center">
                                <div className="p-w-100">
                                  <InputText
                                    className="p-w-100 p-mr-2 e-input-common"
                                    id="PanNo"
                                    type="text"
                                    placeholder="Pan No"
                                    value={pan.pan}
                                    maxLength={20}
                                    onChange={(e) =>
                                      handleChange(e.target.value, "pan")
                                    }
                                  />
                                  {/* <span
                                className="error-msg"
                                style={{ color: "red" }}
                              >
                                {pan.panErr ? pan.panErrText : null}
                              </span> */}
                                </div>
                                {pan.isVerified ? (
                                  <img
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      marginInlineEnd: "2px",
                                    }}
                                    src={yes}
                                  />
                                ) : (
                                  <Button
                                    label="Verify"
                                    disabled={!pan.pan}
                                    onClick={handlePanVerify}
                                    className="e-add-btn p-ml-1 p-mt-1"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="p-sm-12 p-md-4">
                        <div className="custom-inputs e-order-mng">
                          <p className="text p-mb-1">Company Name</p>
                          <InputText
                            className="p-w-100 e-input-common"
                            placeholder="Company Name"
                            value={companyDetails.CompanyName}
                            onChange={(e) =>
                              handleChange(e.target.value, "CompanyName")
                            }
                          />
                          <span className="error-msg" style={{ color: "red" }}>
                            {companyDetails.CompanyNameErr
                              ? companyDetails.CompanyNameErrText
                              : null}
                          </span>
                        </div>
                      </div>
                      <div className="p-sm-12 p-md-4">
                        <div className="custom-inputs e-order-mng">
                          <p className="text p-mb-1">Address</p>
                          <InputText
                            className="p-w-100 e-input-common"
                            placeholder="Address"
                            value={companyDetails.Address}
                            onChange={(e) =>
                              handleChange(e.target.value, "Address")
                            }
                          />
                        </div>
                      </div>
                      <div className="p-sm-12 p-md-4">
                        <div className="custom-inputs e-order-mng">
                          <p className="text p-mb-1">State</p>
                          <InputText
                            className="p-w-100 e-input-common"
                            placeholder="State"
                            value={companyDetails.State}
                            onChange={(e) =>
                              handleChange(e.target.value, "State")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel className="p-mb-2" header="Branch Details">
                <Button
                  label="+ Add Branch"
                  onClick={() => setBranchDialog(true)}
                  className="p-mb-2 e-add-btn"
                />
                <DyanmicDataList
                  data={branches.map((b, index) => ({
                    ...b,
                    SrNo: index + 1,
                    ContactPersons: b.ContactPersons.join(", "),
                    actions: (
                      <Button
                        icon="pi pi-trash"
                        className="p-button-danger"
                        onClick={() => removeBranch(b.id)}
                      />
                    ),
                  }))}
                  columns={initialColumns?.filter((x) => x.isChecked == true)}
                />
              </TabPanel>
            </TabView>
            <div className="p-p-0 p-mt-4">
              <div className="add-export-footer-btns p-d-flex p-ai-center p-jc-end">
                <Button
                  className="primary-btn1"
                  onClick={() => {
                    if (props?.isAddNetwork) {
                      props.handleClose("addSupplier");
                    } else {
                      props.history.push("/admin/network");
                    }
                  }}
                >
                  Cancel
                </Button>
                {!readOnly && (
                  <>
                    <Button
                      className="primary-btn2 p-ml-1"
                      disabled={loading}
                      onClick={AddUpdateNetwork}
                    >
                      Submit
                    </Button>
                  </>
                )}
              </div>
            </div>
          </>
        )}
        {userType === "Customer" && (
          <div className="container-body e-container-body">
            <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
              <div className="p-grid">
                {/* Customer Name */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Customer Name</p>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      placeholder="Customer Name"
                      value={customerDetails.CustomerName}
                      onChange={(e) =>
                        handleCustomerDetailsChange(
                          e.target.value,
                          "CustomerName"
                        )
                      }
                      maxLength={50}
                    />
                    <span className="error-msg" style={{ color: "red" }}>
                      {customerDetails.CustomerNameErr
                        ? customerDetails.CustomerNameErrText
                        : null}
                    </span>
                  </div>
                </div>

                {/* <div className="p-sm-12 p-md-4">
                <div className="custom-inputs e-order-mng">
                  <p className="text p-mb-1">Code</p>
                  <InputText
                    className="p-w-100"
                    placeholder="Code"
                    value={customerDetails.Code}
                    disabled
                  />
                </div>
              </div> */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Gender</p>
                    <Dropdown
                      className="p-w-100"
                      placeholder="Select Gender"
                      value={customerDetails.Gender}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.value, "Gender")
                      }
                      options={[
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                        { label: "Other", value: "Other" },
                      ]}
                    />
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Date of Birth</p>
                    <Calendar
                      className="p-w-100"
                      id="DateOfBirth"
                      type="date"
                      value={customerDetails.DateOfBirth}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e?.value, "DateOfBirth")
                      }
                      // showIcon
                      placeholder="Date of Birth"
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                </div>
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Age</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Age"
                      value={customerDetails.Age}
                      disabled
                    />
                  </div>
                </div>
                {/* Contact No */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Contact No</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Contact No"
                      value={customerDetails.ContactNo}
                      onChange={(e) =>
                        handleCustomerDetailsChange(
                          e.target.value,
                          "ContactNo",
                          /^\d*$/i
                        )
                      }
                      maxLength={10}
                    />
                  </div>
                </div>

                {/* Email ID */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Email ID</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Email"
                      value={customerDetails.EmailId}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.target.value, "EmailId")
                      }
                      maxLength={50}
                    />
                    {/* <span className="error-msg" style={{ color: "red" }}>
                    {customerDetails.EmailIdErr
                      ? customerDetails.EmailIdErrText
                      : null}
                  </span> */}
                  </div>
                </div>

                {/* Address */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Address</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Address"
                      value={customerDetails.Address}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.target.value, "Address")
                      }
                      maxLength={200}
                    />
                  </div>
                </div>

                {/* City */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">City</p>
                    <InputText
                      className="p-w-100"
                      placeholder="City"
                      value={customerDetails.City}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.target.value, "City")
                      }
                      maxLength={50}
                    />
                  </div>
                </div>

                {/* State */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">State</p>
                    <InputText
                      className="p-w-100"
                      placeholder="State"
                      value={customerDetails.State}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.target.value, "State")
                      }
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Pincode</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Pincode"
                      value={customerDetails.PinCode}
                      onChange={(e) =>
                        handleCustomerDetailsChange(e.target.value, "PinCode")
                      }
                      maxLength={10}
                    />
                  </div>
                </div>

                {/* Company Name */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Company Name</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Company Name"
                      value={customerDetails.CompanyName}
                      onChange={(e) =>
                        handleCustomerDetailsChange(
                          e.target.value,
                          "CompanyName"
                        )
                      }
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng">
                      <p className="text p-mb-1">GST No</p>
                      {readOnly ? (
                        <p className="sub-text"> {gst.gst}</p>
                      ) : (
                        <div className="p-d-flex p-ai-center">
                          <div className="p-w-100">
                            <InputText
                              className="p-w-100"
                              id="GstNo"
                              type="text"
                              placeholder="GST No"
                              value={gst.gst}
                              maxLength={20}
                              onChange={(e) =>
                                handleChange(e.target.value, "gst")
                              }
                            />
                            {/* <span className="error-msg" style={{ color: "red" }}>
                            {gst.gstErr ? gst.gstErrText : null}
                          </span> */}
                          </div>
                          {gst.isVerified ? (
                            <img
                              style={{
                                height: "20px",
                                width: "20px",
                                marginInlineEnd: "2px",
                              }}
                              src={yes}
                            />
                          ) : (
                            <Button
                              label="Verify"
                              disabled={!gst.gst}
                              onClick={handleVerify}
                              className="e-add-btn"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-4">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng">
                      <p className="text p-mb-1">Pan No</p>
                      {readOnly ? (
                        <p className="sub-text"> {pan.pan}</p>
                      ) : (
                        <div className="p-d-flex p-ai-center">
                          <div className="p-w-100">
                            <InputText
                              className="p-w-100"
                              id="PanNo"
                              type="text"
                              placeholder="Pan No"
                              value={pan.pan}
                              maxLength={20}
                              onChange={(e) =>
                                handleChange(e.target.value, "pan")
                              }
                            />
                            {/* <span className="error-msg" style={{ color: "red" }}>
                            {pan.panErr ? pan.panErrText : null}
                          </span> */}
                          </div>
                          {pan.isVerified ? (
                            <img
                              style={{
                                height: "20px",
                                width: "20px",
                                marginInlineEnd: "2px",
                              }}
                              src={yes}
                            />
                          ) : (
                            <Button
                              label="Verify"
                              disabled={!pan.pan}
                              onClick={handlePanVerify}
                              className="e-add-btn"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-p-0 p-mt-4">
                <div className="add-export-footer-btns p-d-flex p-ai-center p-jc-end">
                  <Button
                    className="primary-btn1"
                    onClick={() => {
                      if (props?.isAddNetwork) {
                        props.handleClose("addSupplier");
                      } else {
                        props.history.push("/admin/network");
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  {!readOnly && (
                    <>
                      <Button
                        className="primary-btn2 p-ml-1"
                        disabled={loading}
                        onClick={AddUpdateNetwork}
                      >
                        Submit
                      </Button>
                    </>
                  )}
                </div>
                {currentTab === 1 && (
                  <div className="p-d-flex p-ai-center wb-filter-btn">
                    <div className="p-ml-2">
                      <ColumnDropdown
                        columns={filterInitialColumns}
                        onDragEnd={onDragEnd}
                        handleCheckBoxChange={handleCheckBoxChange}
                        handleColumnSave={handleColumnSave}
                        btnClass={"wb-search-btn e-production-filter"}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {userType === "Staff" && (
          <div className="container-body e-container-body">
            <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
              <div className="p-grid">
                {/* Staff Name */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Staff Name</p>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      placeholder="Staff Name"
                      value={staffDetails.StaffName}
                      onChange={(e) =>
                        handleStaffDetailsChange(e.target.value, "StaffName")
                      }
                      maxLength={50}
                    />
                    <span className="error-msg" style={{ color: "red" }}>
                      {staffDetails.StaffNameErr
                        ? staffDetails.StaffNameErrText
                        : null}
                    </span>
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Gender</p>
                    <Dropdown
                      className="p-w-100"
                      placeholder="Select Gender"
                      value={staffDetails.Gender}
                      onChange={(e) =>
                        handleStaffDetailsChange(e.value, "Gender")
                      }
                      options={[
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                        { label: "Other", value: "Other" },
                      ]}
                    />
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Date of Birth</p>
                    <Calendar
                      className="p-w-100"
                      id="DateOfBirth"
                      type="date"
                      value={staffDetails.DateOfBirth}
                      onChange={(e) =>
                        handleStaffDetailsChange(e?.value, "DateOfBirth")
                      }
                      // showIcon
                      placeholder="Date of Birth"
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                </div>

                {/* Contact No */}
                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Contact No</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Contact No"
                      value={staffDetails.ContactNo}
                      onChange={(e) =>
                        handleStaffDetailsChange(
                          e.target.value,
                          "ContactNo",
                          /^\d*$/i
                        )
                      }
                      maxLength={10}
                    />
                  </div>
                </div>

                <div className="p-sm-12 p-md-4">
                  <div className="custom-inputs e-order-mng">
                    <p className="text p-mb-1">Pin</p>
                    <InputText
                      className="p-w-100"
                      placeholder="Pin"
                      value={staffDetails.Pin}
                      onChange={(e) =>
                        handleStaffDetailsChange(e.target.value, "Pin")
                      }
                      maxLength={10}
                    />
                    <span className="error-msg" style={{ color: "red" }}>
                      {staffDetails.PinErr ? staffDetails.PinErrText : null}
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-p-0 p-mt-4">
                <div className="add-export-footer-btns p-d-flex p-ai-center p-jc-end">
                  <Button
                    className="primary-btn1"
                    onClick={() => {
                      if (props?.isAddNetwork) {
                        props.handleClose("addSupplier");
                      } else {
                        props.history.push("/admin/network");
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  {!readOnly && (
                    <>
                      <Button
                        className="primary-btn2 p-ml-1"
                        disabled={loading}
                        onClick={AddUpdateNetwork}
                      >
                        Submit
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Dialog
        open={branchDialog}
        aria-labelledby="cha-form-dialog-title"
        onClose={handleClose}
        className="stock-modal"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Branch</div>
          <div
            className="dialog-close"
            onClick={(e) => this.handleClose("AddMaster")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem xs={12} md={6}>
              <div className="p-w-100 p-mt-3">
                <div className="custom-inputs e-order-mng">
                  <label>Branch Name</label>
                  <InputText
                    autoFocus
                    className="p-w-100 e-input-common"
                    placeholder="Enter Branch Name"
                    value={newBranch.BranchName}
                    maxLength={50}
                    onChange={(e) =>
                      handleBranchChange(e.target.value, "BranchName")
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {newBranch.BranchNameErr
                      ? newBranch.BranchNameErrText
                      : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Address */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100 p-mt-3">
                <div className="custom-inputs e-order-mng">
                  <label className="text p-mb-1">Address</label>
                  <InputText
                    className="p-w-100 e-input-common"
                    placeholder="Enter Address"
                    maxLength={300}
                    value={newBranch.Address}
                    onChange={(e) =>
                      handleBranchChange(e.target.value, "Address")
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {newBranch.AddressErr ? newBranch.AddressErrText : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Post */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100 p-mt-3">
                <div className="custom-inputs e-order-mng">
                  <label className="text p-mb-1">Post</label>
                  <InputText
                    className="p-w-100 e-input-common"
                    placeholder="Enter Post"
                    maxLength={50}
                    value={newBranch.Post}
                    onChange={(e) => handleBranchChange(e.target.value, "Post")}
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {newBranch.PostErr ? newBranch.PostErrText : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Mobile No */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100 p-mt-3">
                <div className="custom-inputs e-order-mng">
                  <label className="text p-mb-1">Mobile No</label>
                  <InputText
                    className="p-w-100 e-input-common"
                    placeholder="Enter Mobile No"
                    maxLength={10}
                    value={newBranch.MobileNo}
                    onChange={(e) =>
                      handleBranchChange(e.target.value, "MobileNo", /^\d*$/i)
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {newBranch.MobileNoErr ? newBranch.MobileNoErrText : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Email ID */}
            <GridItem xs={12} md={6}>
              <div className="p-w-100 p-mt-3">
                <div className="custom-inputs e-order-mng">
                  <label className="text p-mb-1">Email ID</label>
                  <InputText
                    className="p-w-100 e-input-common"
                    placeholder="Enter Email ID"
                    value={newBranch.EmailId}
                    maxLength={80}
                    onChange={(e) =>
                      handleBranchChange(e.target.value, "EmailId")
                    }
                  />
                  <span className="error-msg" style={{ color: "red" }}>
                    {newBranch.EmailIdErr ? newBranch.EmailIdErrText : null}{" "}
                  </span>
                </div>
              </div>
            </GridItem>

            {/* Contact Persons */}
            {newBranch.ContactPersons.map((cp, i) => (
              <GridItem xs={12} md={6} key={i}>
                <div className="p-w-100 p-mt-3">
                  <div className="custom-inputs e-order-mng">
                    <label className="text p-mb-1">
                      Contact Person {i + 1}
                    </label>
                    <div className="p-d-flex p-ai-center">
                      <InputText
                        className="p-w-100 e-input-common"
                        placeholder={`Enter Contact Person ${i + 1}`}
                        value={cp}
                        maxLength={50}
                        onChange={(e) => {
                          const updated = [...newBranch.ContactPersons];
                          updated[i] = e.target.value;
                          setNewBranch({
                            ...newBranch,
                            ContactPersons: updated,
                          });
                        }}
                      />
                      {newBranch.ContactPersons.length > 1 && (
                        <i
                          class="icon-delete p-ml-2"
                          onClick={() => {
                            let tempBranch = { ...newBranch };
                            tempBranch.ContactPersons.splice(i, 1);
                            setNewBranch(tempBranch);
                          }}
                        ></i>
                      )}
                    </div>
                  </div>
                </div>
              </GridItem>
            ))}

            {/* Add Contact Person Button */}
            <GridItem xs={12} md={12}>
              <Button
                label="+ Add Contact Person"
                onClick={() =>
                  setNewBranch({
                    ...newBranch,
                    ContactPersons: [...newBranch.ContactPersons, ""],
                  })
                }
                className="p-button-sm p-button-text p-mt-2"
              />
            </GridItem>
          </GridContainer>
        </DialogContent>

        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => setBranchDialog(false)}
          >
            Cancel
          </Button>
          <Button className="primary-btn" color="primary" onClick={addBranch}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddNetwork;
